import { useNavigate } from "react-router-dom";
import { FileAudio, Layers } from "lucide-react";

export const EpisodeTabs = ({ active }) => {
  const nav = useNavigate();
  const tabs = [["single", "Single episode", FileAudio, "/episodes/new"], ["batch", "Batch (several episodes, one GPU)", Layers, "/episodes/batch"]];
  return (
    <div data-testid="episode-tabs" className="inline-flex rounded-sm border border-[#253044] bg-[#0B0E14] p-1 gap-1">
      {tabs.map(([k, label, Icon, to]) => (
        <button key={k} data-testid={`tab-${k}`} onClick={() => nav(to)} className={`flex items-center gap-2 px-4 h-9 rounded-sm text-sm transition-colors ${active === k ? "bg-cyan-500/15 text-cyan-200 border border-cyan-700" : "text-slate-400 hover:text-slate-100"}`}>
          <Icon size={14} /> {label}
        </button>
      ))}
    </div>
  );
};
